<template>
  <!-- // 项目续约明细表 -->
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="100px"
      >
        <el-form-item label="所属部门" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.bmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            @change="handleChangeBm"
            style="width: 200px"
          >
            <el-option
              v-for="item in zxlc.bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目状态" prop="xmzt">
          <el-select
            ref="name"
            v-model="listQuery.xmzt"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
            @change="handleChangeXmzt"
          >
            <el-option
              v-for="item in zxlc.xmztList"
              :key="item.dictLabel"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="txlx">
          <el-select
            ref="txlx"
            v-model="listQuery.xmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in zxlc.xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="合同状态" prop="htzt">
          <el-select
            ref="name"
            v-model="listQuery.htzt"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in zxlc.htztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="合作期限" prop="hzqx">
          <el-select
            ref="hzqx"
            v-model="listQuery.hzqx"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in zxlc.hzqxList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="按续约结果" prop="xyjg">
          <el-select
            ref="xyjg"
            v-model="listQuery.xyjg"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
            style="width: 200px"
          >
            <el-option
              v-for="item in zxlc.xyjgList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="合同到期时间" prop="name">
          <el-date-picker
            v-model="listQuery.qssj"
            align="right"
            type="date"
            placeholder="选择日期"
            size="small"
            :picker-options="pickerStartTime"
            style="width: 200px"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="listQuery.jssj"
            align="right"
            type="date"
            placeholder="选择日期"
            size="small"
            :picker-options="pickerEndTime"
            style="width: 200px"
          >
          </el-date-picker>
        </el-form-item>

        <span style="margin-top: 4px; margin-left: 15px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >搜 索</el-button
          >
        </span>
        <span style="margin-top: 4px; margin-left: 15px; display: inline-block">
          <el-button size="small" @click="reset()">重 置</el-button>
        </span>
      </el-form>
      <div style="margin: 10px 0">
        <!-- <el-button
          type="primary"
          size="small"
          @click="handleToDj()"
          v-if="user.bntqxzt == 2"
          >续约结果登记</el-button
        > -->
        <el-button
          type="primary"
          size="small"
          style="margin-left: 15px"
          @click="handleToTj()"
          >续约统计</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 15px"
          size="small"
          @click="exportList()"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <div>
        <el-table
          v-loading="listLoading"
          :data="zxlc.xymxList.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :max-height="height"
          id="xymxList"
        >
          <el-table-column
            label="所属部门"
            prop="bmmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="项目名称"
            prop="xmjc"
            :show-overflow-tooltip="true"
            min-width="150px"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="项目状态"
            prop="xmzt"
            :show-overflow-tooltip="true"
            min-width="120px"
            align="center"
            fixed
          ></el-table-column>

          <el-table-column
            label="合同起止日期"
            prop="htzq"
            min-width="170px"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="合作期限(年)"
            prop="hznx"
            min-width="140px"
            align="center"
            sortable
            fixed
          >
          </el-table-column>
          <el-table-column
            label="续约结果"
            prop="xyjg"
            min-width="120px"
            align="center"
            fixed
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="由区域总监进行发续约登记"
                placement="top"
              >
                <div>
                  续约结果&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div
                v-show="scope.row.xyjg == '未登记'"
                style="
                  color: #c6d70a;
                  text-decoration: underline;
                  cursor: pointer;
                "
                @click="handleToDj(scope.row)"
              >
                {{ scope.row.xyjg }}
              </div>
              <div v-show="scope.row.xyjg == '按DS模式续约'">
                <el-popover
                  class="item"
                  trigger="hover"
                  content="由区域总监进行发续约登记"
                  placement="top"
                >
                  <div>
                    <div style="line-height: 28px">
                      <div style="font-weight: 700; font-size: 16px">
                        按DS模式续约
                      </div>
                      <div>
                        <span v-html="scope.row.xyjgms"></span>
                      </div>
                    </div>
                  </div>
                  <div slot="reference" style="color: #52c41a">
                    {{ scope.row.xyjg }}&nbsp;
                  </div>
                </el-popover>
              </div>

              <div v-show="scope.row.xyjg == '续约不成功'">
                <el-popover
                  class="item"
                  trigger="hover"
                  content="由区域总监进行发续约登记"
                  placement="top"
                >
                  <div>
                    <div style="line-height: 28px">
                      <div style="font-weight: 700; font-size: 16px">
                        续约不成功原因
                      </div>
                      <div>
                        <span v-html="scope.row.xyjgms"></span>
                      </div>
                    </div>
                  </div>
                  <div slot="reference" style="color: #c6d70a">
                    {{ scope.row.xyjg }}&nbsp;
                  </div>
                </el-popover>
              </div>
              <div v-show="scope.row.xyjg == '降级续约'">
                <el-popover
                  class="item"
                  trigger="hover"
                  content="由区域总监进行发续约登记"
                  placement="top"
                >
                  <div>
                    <div style="line-height: 28px">
                      <div style="font-weight: 700; font-size: 16px">
                        降级续约
                      </div>
                      <div>
                        <span v-html="scope.row.xyjgms"></span>
                      </div>
                    </div>
                  </div>
                  <div slot="reference" style="color: #f5222d">
                    {{ scope.row.xyjg }}&nbsp;
                  </div>
                </el-popover>
              </div>
              <!-- <div v-show="scope.row.xyjg == '未登记'">
                  <div slot="reference" style="color: rgba(0, 0, 0, 0.2)">
                    {{ scope.row.xyjg }}&nbsp;
                  </div>
                </div> -->
            </template>
          </el-table-column>
          <el-table-column
            label="发函结果"
            prop="fyjg"
            min-width="100px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="由区域总监进行发函确认 由效果办专员进行发函处理"
                placement="top"
              >
                <div>
                  发函结果&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div
                v-if="scope.row.fyjg == '已处理'"
                @click="handleToView(scope.row, true)"
                style="
                  color: #52c41a;
                  text-decoration: underline;
                  cursor: pointer;
                "
              >
                已处理
              </div>
              <div
                v-if="scope.row.fyjg == '待处理'"
                @click="handleToView(scope.row)"
                style="
                  color: #c6d70a;
                  text-decoration: underline;
                  cursor: pointer;
                "
              >
                待处理
              </div>
              <div class="" v-else-if="scope.row.fyjg == '待确认'">
                <el-popover
                  placement="top"
                  trigger="click"
                  :disabled="user.bntqxzt != 2"
                >
                  <div
                    style="
                      font-weight: 700;
                      line-height: 32px;
                      margin-bottom: 5px;
                    "
                  >
                    {{ scope.row.xmjc }}续约发函确认
                  </div>
                  <div style="display: flex; justify-content: space-around">
                    <el-button size="mini" @click="handleWxfh(scope.row)"
                      >无需发函</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="handleToApply(scope.row)"
                      >需要发函</el-button
                    >
                  </div>
                  <div
                    slot="reference"
                    style="
                      color: #c6d70a;
                      text-decoration: underline;
                      cursor: pointer;
                    "
                  >
                    待确认
                  </div>
                </el-popover>
              </div>
              <div
                v-if="scope.row.fyjg == '不发函'"
                style="color: rgba(0, 0, 0, 0.2)"
              >
                不发函
              </div>
            </template>
          </el-table-column>
          <el-table-column label="续约基础工作" align="center">
            <el-table-column
              label="项目效果自评"
              prop="项目效果自评"
              min-width="120px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.项目效果自评">
                    <div
                      :style="{
                        color:
                          scope.row.项目效果自评.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '项目效果自评',
                          scope.row.项目效果自评
                        )
                      "
                    >
                      {{ scope.row.项目效果自评.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h1id)"
                    >
                      {{ scope.row.项目效果自评.substring(4, 12) }}
                    </div>
                    <div
                      :style="{
                        color:
                          scope.row.项目效果自评.substring(13, 17) == '效果明显'
                            ? 'rgb(82, 196, 26)'
                            : scope.row.项目效果自评.substring(13, 17) ==
                              '效果一般'
                            ? '#F59A23'
                            : '#ff0000',
                      }"
                    >
                      {{ scope.row.项目效果自评.substring(13, 17) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '项目效果自评',
                        scope.row.项目效果自评
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="成绩单规划清单"
              prop="成绩单规划清单"
              min-width="120px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.成绩单规划清单">
                    <div
                      :style="{
                        color:
                          scope.row.成绩单规划清单.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '成绩单规划清单',
                          scope.row.成绩单规划清单
                        )
                      "
                    >
                      {{ scope.row.成绩单规划清单.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h2id)"
                    >
                      {{ scope.row.成绩单规划清单.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '成绩单规划清单',
                        scope.row.成绩单规划清单
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="成绩单一览表"
              prop="成绩单一览表"
              min-width="110px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.成绩单一览表">
                    <div
                      :style="{
                        color:
                          scope.row.成绩单一览表.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '成绩单一览表',
                          scope.row.成绩单一览表
                        )
                      "
                    >
                      {{ scope.row.成绩单一览表.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h3id)"
                    >
                      {{ scope.row.成绩单一览表.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '成绩单一览表',
                        scope.row.成绩单一览表
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="一把手认知评估"
              prop="一把手认知评估"
              min-width="120px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.一把手认知评估">
                    <div
                      :style="{
                        color:
                          scope.row.一把手认知评估.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '一把手认知评估',
                          scope.row.一把手认知评估
                        )
                      "
                    >
                      {{ scope.row.一把手认知评估.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h4id)"
                    >
                      {{ scope.row.一把手认知评估.substring(4, 12) }}
                    </div>
                    <div
                      :style="{
                        color:
                          scope.row.一把手认知评估.substring(13, 17) ==
                          '效果明显'
                            ? 'rgb(82, 196, 26)'
                            : scope.row.一把手认知评估.substring(13, 17) ==
                              '效果一般'
                            ? '#F59A23'
                            : '#ff0000',
                      }"
                    >
                      {{ scope.row.一把手认知评估.substring(13, 17) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '一把手认知评估',
                        scope.row.一把手认知评估
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="续约流程执行" align="center">
            <el-table-column
              label="客户拜访"
              prop="客户拜访"
              min-width="110px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <!-- <div
                    style="color: rgb(82, 196, 26)"
                    v-if="
                      scope.row.客户拜访 &&
                      scope.row.客户拜访.indexOf('已完成') > -1
                    "
                  >
                    {{ scope.row.客户拜访 }}
                  </div>
                  <div
                    style="color: #f88825"
                    v-else-if="
                      scope.row.客户拜访 &&
                      scope.row.客户拜访.indexOf('未完成') > -1
                    "
                  >
                    {{ scope.row.客户拜访 }}
                  </div> -->

                  <div v-if="scope.row.客户拜访">
                    <div
                      :style="{
                        color:
                          scope.row.客户拜访.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '客户拜访',
                          scope.row.客户拜访
                        )
                      "
                    >
                      {{ scope.row.客户拜访.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h5id)"
                    >
                      {{ scope.row.客户拜访.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '客户拜访',
                        scope.row.客户拜访
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="策略研讨"
              prop="策略研讨"
              min-width="100px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.策略研讨">
                    <div
                      :style="{
                        color:
                          scope.row.策略研讨.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '策略研讨',
                          scope.row.策略研讨
                        )
                      "
                    >
                      {{ scope.row.策略研讨.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h6id)"
                    >
                      {{ scope.row.策略研讨.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '策略研讨',
                        scope.row.策略研讨
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="报告编写"
              prop="报告编写"
              min-width="100px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.报告编写">
                    <div
                      :style="{
                        color:
                          scope.row.报告编写.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '报告编写',
                          scope.row.报告编写
                        )
                      "
                    >
                      {{ scope.row.报告编写.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h7id)"
                    >
                      {{ scope.row.报告编写.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '报告编写',
                        scope.row.报告编写
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="续约汇报"
              prop="续约汇报"
              min-width="100px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.续约汇报">
                    <div
                      :style="{
                        color:
                          scope.row.续约汇报.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '续约汇报',
                          scope.row.续约汇报
                        )
                      "
                    >
                      {{ scope.row.续约汇报.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h8id)"
                    >
                      {{ scope.row.续约汇报.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '续约汇报',
                        scope.row.续约汇报
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="商务沟通阶段"
              prop="商务沟通阶段"
              min-width="120px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.商务沟通阶段">
                    <div
                      :style="{
                        color:
                          scope.row.商务沟通阶段.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '商务沟通阶段',
                          scope.row.商务沟通阶段
                        )
                      "
                    >
                      {{ scope.row.商务沟通阶段.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h9id)"
                    >
                      {{ scope.row.商务沟通阶段.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '商务沟通阶段',
                        scope.row.商务沟通阶段
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="合同签订阶段"
              prop="合同签订阶段"
              min-width="120px"
              align="center"
            >
              <template slot-scope="scope">
                <div
                  :style="{ cursor: user.bmbh === '00504' ? 'pointer' : '' }"
                >
                  <div v-if="scope.row.合同签订阶段">
                    <div
                      :style="{
                        color:
                          scope.row.合同签订阶段.substring(0, 3) == '已完成'
                            ? 'rgb(82, 196, 26)'
                            : '#ff0000',
                      }"
                      @click="
                        handleToChangeResult(
                          scope.row,
                          '合同签订阶段',
                          scope.row.合同签订阶段
                        )
                      "
                    >
                      {{ scope.row.合同签订阶段.substring(0, 3) }}
                    </div>
                    <div
                      style="color: rgb(82, 196, 26)"
                      @click="handleViewCgw(scope.row.h10id)"
                    >
                      {{ scope.row.合同签订阶段.substring(4, 12) }}
                    </div>
                  </div>
                  <div
                    v-else
                    @click="
                      handleToChangeResult(
                        scope.row,
                        '合同签订阶段',
                        scope.row.合同签订阶段
                      )
                    "
                  >
                    -
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="zxlc.xymxList.total > 0"
          :total="zxlc.xymxList.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`项目续约发函${this.mxParams.isView ? '查看' : '处理'}-${
        mxParams.xmjc
      }`"
      :visible.sync="viewDialog"
      width="90%"
      v-if="viewDialog"
      id="mx-dialog"
    >
      <ViewForm ref="view" @giveFather="getSon" :mxParams="mxParams"></ViewForm>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="handleConfirm()"
          v-if="!this.mxParams.isView"
          >确认发函完成</el-button
        >
        <el-button @click="viewDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="项目续约发函申请"
      :visible.sync="applyDialog"
      width="90%"
      v-if="applyDialog"
      id="mx-dialog"
    >
      <ApplyForm
        ref="apply"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></ApplyForm>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit(1)">提 交</el-button>
        <el-button @click="applyDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="项目续约结果登记"
      :visible.sync="djDialog"
      width="90%"
      v-if="djDialog"
      id="mx-dialog"
    >
      <XyjgdjForm
        ref="xyjgdjForm"
        @giveFather="getSon"
        :mxParams="mxParams"
      ></XyjgdjForm>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave()">提 交</el-button>
        <el-button @click="handleCloseDj()">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${resultRow.pointName}结果修改`"
      :visible.sync="changeResultDialog"
      width="600px"
      v-if="changeResultDialog"
      id="mx-dialog"
    >
      <div>
        <el-form
          ref="editForm"
          label-width="120px"
          :hide-required-asterisk="false"
          :rules="editRules"
          :model="resultRow"
        >
          <el-form-item label="流程节点:" prop="pointName">
            <el-input
              show-word-limit
              :placeholder="resultRow.pointName"
              v-model="resultRow.pointName"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="执行结果:" prop="zxjg">
            <el-select
              ref="zxjg"
              v-model="resultRow.zxjg"
              placeholder="全部"
              class="filter-item"
              style="width: 100%"
              @change="handleChangePointResult"
            >
              <el-option
                v-for="item in resultList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="完成时间:"
            prop="wcsj"
            v-if="resultRow.zxjg === '已完成'"
          >
            <el-date-picker
              v-model="resultRow.wcsj"
              type="date"
              placeholder="选择日期"
              size="small"
              style="width: 100%"
              @input="handleChangeWcsjResult"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="效果等级:"
            prop="xgdj"
            v-if="
              (resultRow.pointName == '项目效果自评' ||
                resultRow.pointName == '一把手认知评估') &&
              resultRow.zxjg === '已完成'
            "
          >
            <el-select
              v-model="resultRow.xgdj"
              placeholder="全部"
              class="filter-item"
              style="width: 100%"
              @change="handleChangeXgdjResult"
            >
              <el-option
                v-for="item in zxlc.xgdjList"
                :key="item.dictLabel"
                :label="item.dictLabel"
                :value="item.dictLabel"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSavePointResult()"
          >提 交</el-button
        >
        <el-button @click="changeResultDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="成果物查看"
      :visible.sync="cgwDialog"
      width="900px"
      v-if="cgwDialog"
    >
      <div>
        <el-table
          :data="cgwList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :header-cell-style="tableHeaderColor"
          border
        >
          <el-table-column
            label="成果物名称"
            align="center"
            prop="name"
            min-width="200px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="上传人"
            align="center"
            prop="xm"
            min-width="200px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="上传时间"
            align="center"
            prop="uploadtime"
            min-width="200px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="操作"
            align="center"
            prop="message"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="text"
                @click="handleViewCgwFile(scope.row)"
                style="padding: 0"
                >预览</el-button
              >
              <el-button
                size="small"
                type="text"
                style="padding: 0; margin-left: 15px"
                @click="handleDownloadCgwFile(scope.row)"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  exportXymxList,
  getTaskFileList,
  updateXmxyfh,
  xmxybg,
} from "@/api/zxlc";
import Pagination from "@/components/Pagination";
import { addExportFileDate, deepClone, formatMomentDate } from "@/utils/utils";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import { mapGetters } from "vuex";
import ApplyForm from "./applyForm.vue";
import ViewForm from "./viewForm.vue";
import XyjgdjForm from "./xyjgdjForm.vue";
export default {
  // 列表分页
  name: "xmxyList",
  components: { Treeselect, Pagination, XyjgdjForm, ApplyForm, ViewForm },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc", "xgpg"]),
    pickerStartTime() {
      return {
        disabledDate: (time) => {
          if (this.listQuery.jssj) {
            return time.getTime() > new Date(this.listQuery.jssj).getTime();
          }
        },
      };
    },
    pickerEndTime() {
      return {
        disabledDate: (time) => {
          if (this.listQuery.qssj) {
            return time.getTime() < new Date(this.listQuery.qssj).getTime();
          }
        },
      };
    },
  },
  data: () => {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      height: 800,
      listQuery: {
        bmbh: null,
        xmbh: null,
        htzt: null,
        xmzt: "1",
        hzqx: null,
        xyjg: null,
        qssj: null,
        jssj: null,
        page: 1,
        pageSize: 20,
      },
      listLoading: false,
      dclVisible: false,
      applyDialog: false,
      viewDialog: false,
      cgwDialog: false,
      djDialog: false,
      mxParams: {},
      canClick: true,
      changeResultDialog: false,
      resultRow: {
        zxjg: null,
        wcsj: null,
        xgdj: null,
        xmbh: null,
        htid: null,
      },
      resultList: ["已完成", "未完成"],
      zxjg: null,
      cgwList: [],
      editRules: {
        zxjg: [
          { required: true, message: "执行结果不能为空", trigger: "change" },
        ],

        wcsj: [
          { required: true, message: "完成时间不能为空", trigger: "change" },
        ],
        xgdj: [
          {
            required: true,
            message: "效果等级不能为空",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("common/fetchUserInfoAction");
    if (this.zxlc.bmList.length == 0) {
      this.$store.dispatch("zxlc/fetchBmListAction", { type: 2, range: 1 });
    }
    this.$store.dispatch("zxlc/fetchXmxxListAction", {
      range: 1,
      xmzt: this.listQuery.xmzt,
      bmbh: this.listQuery.bmbh,
    });
    if (this.zxlc.htztList.length == 0) {
      this.$store.dispatch("zxlc/fetchHtztListAction", {
        dictType: "htzt",
        type: 2,
      });
    }
    if (this.zxlc.xmztList.length == 0) {
      this.$store.dispatch("zxlc/fetchXmztListAction", {
        dictType: "xmgl_xmzt",
        type: 2,
      });
    }
    if (this.zxlc.hzqxList.length == 0) {
      this.$store.dispatch("zxlc/fetchHzqxListAction");
    }
    if (this.zxlc.xyjgList.length == 0) {
      this.$store.dispatch("zxlc/fetchXyjgListAction");
    }

    if (localStorage.getItem("zxlc_xmxy_mx_bmbh")) {
      this.listQuery.bmbh = localStorage.getItem("zxlc_xmxy_mx_bmbh");
      localStorage.removeItem("zxlc_xmxy_mx_bmbh");
    }
    if (this.zxlc.xgdjList.length == 0) {
      this.$store.dispatch("zxlc/fetchXgdjListAction");
    }
    // if (this.user.bntqxzt == 2) {
    //   this.listQuery.bmbh = this.user.bmbh;
    // }
    this.getList();
  },
  mounted() {
    this.startWatching();
  },
  methods: {
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{
          bmbh: null,
          xmbh: null,
          htzt: null,
          xmzt: "1",
          hzqx: null,
          xyjg: null,
          jssj: null,
          qssj: null,
        },
      };
      this.$store.dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        xmzt: this.listQuery.xmzt,
        bmbh: this.listQuery.bmbh,
      });
    },
    getList() {
      this.listLoading = true;
      this.$store
        .dispatch("zxlc/fetchXymxListAction", {
          ...this.listQuery,
          qssj: this.listQuery.qssj
            ? formatMomentDate(this.listQuery.qssj)
            : null,
          jssj: this.listQuery.jssj
            ? formatMomentDate(this.listQuery.jssj)
            : null,
        })
        .then((res) => {
          if (res.code == 0) {
            this.listLoading = false;
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 75;
          }
        });
    },
    handleChangeBm(e) {
      this.$store.dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        xmzt: this.listQuery.xmzt,
        bmbh: e,
      });
      this.listQuery.xmbh = null;
    },
    handleChangeXmzt(i) {
      this.$store.dispatch("zxlc/fetchXmxxListAction", {
        range: 1,
        xmzt: i,
        bmbh: this.listQuery.bmbh,
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleSave() {
      this.$refs.xyjgdjForm.saveForm();
      this.mxParams = {};
    },
    handleCloseDj() {
      this.mxParams = false;
      this.djDialog = false;
    },
    handleToApply(row) {
      this.applyDialog = true;
      this.mxParams = row;
    },
    handleToDj(row) {
      this.djDialog = true;
      this.mxParams = row;
    },
    handleToView(row, isView) {
      // if (row.fyjg == "待处理" && this.user.bntqxzt != 1) return;
      if (row.fyjg == "待确认" && this.user.bntqxzt != 2) return;
      this.viewDialog = true;
      this.mxParams = row;
      this.mxParams.isView = isView;
      if (row.fyjg == "待处理" && this.user.bntqxzt != 1) {
        this.mxParams.isView = true;
      }
    },
    handleWxfh(row) {
      if (this.canClick == false) return;
      this.canClick = false;
      updateXmxyfh({ id: row.id, fhlx: 1 }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.dclVisible = false;
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
        this.canClick = true;
      });
    },
    handleConfirm() {
      this.$refs.view.submitUpload();
    },
    handleSaveEdit() {
      this.$refs.edit.handleEdit();
      setTimeout(() => {
        this.getList();
      }, 500);
    },
    getSon() {
      this.viewDialog = false;
      this.djDialog = false;
      this.applyDialog = false;
      this.getList();
    },
    handleChangeStatus() {
      this.listQuery.page = 1;
      this.getList();
    },
    exportList() {
      const { bmbh, xmbh, htzt, hzqx, xyjg, xmzt } = this.listQuery;
      const qssj = this.listQuery.qssj
        ? formatMomentDate(this.listQuery.qssj)
        : null;
      const jssj = this.listQuery.jssj
        ? formatMomentDate(this.listQuery.jssj)
        : null;
      exportXymxList({ bmbh, xmbh, htzt, xmzt, hzqx, xyjg, jssj, qssj }).then(
        (res) => {
          if (res.code === 0) {
            const fileName = res.msg.substr(
              res.msg.indexOf("_") + 1,
              res.msg.length
            );
            const filePath = res.msg;
            const url =
              window.g.apiUrl +
              "system/downloadFile?fileName=" +
              fileName +
              "&filePath=" +
              filePath; // 组装a标签
            const elink = document.createElement("a"); // 设置下载文件名
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = url;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "error",
            });
          }
        }
      );
    },
    handleSubmit() {
      this.$refs.apply.submitUpload();
    },
    handleToChangeResult(row, pointName, pointStatus) {
      if (this.user.bmbh === "00504") {
        // this.resultRow = deepClone(row);
        this.resultRow.xmbh = row.xmbh;
        this.resultRow.htid = row.htid;
        this.resultRow.pointName = pointName;
        if (pointStatus) {
          this.resultRow.zxjg = pointStatus
            ? pointStatus.substring(0, 3)
            : null;
          if (this.resultRow.zxjg == "已完成") {
            this.resultRow.wcsj = pointStatus
              ? moment(pointStatus.substring(4, 12))
              : null;
            this.resultRow.xgdj = pointStatus
              ? pointStatus.substring(13, 17)
              : null;
          } else {
            this.resultRow.wcsj = moment();
            this.resultRow.xgdj = "效果明显";
          }
        } else {
          this.resultRow.zxjg = "未完成";
        }

        // this.zxjg = pointStatus === "-" ? null : pointStatus;
        this.changeResultDialog = true;
      }
    },
    handleChangePointResult(e) {
      this.resultRow.zxjg = e;
      this.$forceUpdate();
    },
    handleChangeWcsjResult(e) {
      this.resultRow.wcsj = e;
      this.$forceUpdate();
    },
    handleChangeXgdjResult(e) {
      this.resultRow.xgdj = e;
      this.$forceUpdate();
    },
    handleSavePointResult() {
      // console.log(this.resultRow.wcsj);
      //  const wcsj =  this.resultRow.zxjg?
      // return;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let zxjg = null;
          if (this.resultRow.zxjg === "已完成") {
            zxjg =
              this.resultRow.zxjg +
              "," +
              moment(this.resultRow.wcsj).format("YYYYMMDD") +
              "," +
              this.resultRow.xgdj;
          } else {
            zxjg = this.resultRow.zxjg;
          }
          const params = {
            xmbh: this.resultRow.xmbh,
            htid: this.resultRow.htid,
            lcjd: this.resultRow.pointName,
            zxjg: zxjg,
          };
          xmxybg(params).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.changeResultDialog = false;
              this.getList();
            }
          });
        }
      });
    },

    handleViewCgw(id) {
      this.cgwDialog = true;
      this.cgwList = [];
      if (!id) {
        return;
      }
      getTaskFileList({ id }).then((res) => {
        if (res.code == 0) {
          this.cgwList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleViewCgwFile(row) {
      const url = row.previewurl;
      window.open(url);
    },
    handleDownloadCgwFile(row) {
      const filePath = row.url;
      let fileName = addExportFileDate(row.name);
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    handleToTj(xmzt) {
      //测试生产使用
      if (xmzt !== undefined) {
        localStorage.setItem("zxlc_xmxy_tj_xmzt", xmzt);
      } else {
        localStorage.removeItem("zxlc_xmxy_tj_xmzt");
      }
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=83`;
      var menuName = "续约统计";
      var dataIndex = Math.round(Math.random() * 10000);
      var data1 = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data1, "*");
    },
    startWatching() {
      setInterval(() => {
        const current = localStorage.getItem("zxlc_xmxy_mx_bmbh");
        if (current) {
          location.reload();
        }
      }, 1000);
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>

